import { columnForField } from "../../../Grid/columnForField";
import { kendoDateCell } from "../../../Layout/Grid/Cell/DateCell";
import { RateAgreementOverviewItem } from "../RateAgreementOverviewItem";
import {
  rateAgreementStatusTypeColumnMenu,
  rateAgreementStatusTypeEnumCell,
} from "../RateAgreementState/RateAgreementStatusTypeEnumCell";

export function RateAgreementGridColumns() {
  return [
    columnForField<RateAgreementOverviewItem>("RateAgreementName", {
      title: "Rate Agreement",
      width: "220px",
    }),
    columnForField<RateAgreementOverviewItem>("CarrierName", {
      title: "Carrier",
      width: "300px",
    }),
    columnForField<RateAgreementOverviewItem>("CarrierGsdb", {
      title: "GSDB",
      width: "300px",
    }),
    columnForField<RateAgreementOverviewItem>("StartDate", {
      title: "Start Date",
      filter: "date",
      width: "220px",
      cell: kendoDateCell(),
    }),
    columnForField<RateAgreementOverviewItem>("EndDate", {
      title: "End Date",
      filter: "date",
      width: "220px",
      cell: kendoDateCell(),
    }),
    columnForField<RateAgreementOverviewItem>("DescriptionOfService", {
      title: "Description of Service",
      width: "400px",
    }),
    columnForField<RateAgreementOverviewItem>("Status", {
      hideFilterCell: true,
      columnMenu: rateAgreementStatusTypeColumnMenu,
      cell: rateAgreementStatusTypeEnumCell,
    }),
  ];
}
